import React from 'react';
import styles from './styles/Switch.module.scss';
import { ConsumptionApp } from '../../omaLummeContext';

type SwitchProps = {
  offLabel: string;
  onLabel: string;
  context?: string;
  dispatchAction?: string;
  onChange?: React.Dispatch<React.SetStateAction<boolean>>;
  active: boolean;
  toggle?: boolean;
  disabled?: boolean;
};

const Switch: React.FunctionComponent<SwitchProps> = (props: SwitchProps) => {
  const dispatchConsumption = ConsumptionApp.useDispatch();
  const { offLabel, onLabel, context, dispatchAction, onChange, active, toggle, disabled } = props;

  const id = (Math.random() + 1).toString(36).substring(2);

  return (
    <label className={`${styles.switch} ${toggle ? styles.toggle : undefined} ${disabled ? styles.disabled : undefined}`} htmlFor={id}>
      <input
        type="checkbox"
        id={id}
        name={id}
        checked={active}
        disabled={disabled}
        onChange={(e) => {
          if (context && dispatchAction) {
            if (context === 'consumption') {
              // @ts-ignore
              dispatchConsumption([dispatchAction, e.target.checked]);
            }
          } else if (onChange) {
            onChange(e.target.checked);
          }
        }}
      />
      <div>
        <span className={styles.off} aria-selected={!active}>
          {(!toggle || (toggle && !active)) && offLabel}
        </span>
        <span className={styles.on} aria-selected={active}>
          {(!toggle || (toggle && active)) && onLabel}
        </span>
      </div>
    </label>
  );
};

export default Switch;
